import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_SLIDER = createActionType("ADD_SLIDER");
export const GET_SLIDERS = createActionType("GET_SLIDERS");
export const GET_SLIDER_BY_ID = createActionType("GET_SLIDER_BY_ID");
export const EDIT_SLIDER = createActionType("EDIT_SLIDER");
export const REMOVE_SLIDER = createActionType("REMOVE_SLIDER");

export const addSlider = (data: any) =>
  createAsyncAction(ADD_SLIDER, "/slideshow/add_slideshow", "post", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const getSlider = () =>
  createAsyncAction(
    GET_SLIDERS,
    "/slideshow/get_all_slideshows",
    "get",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const getSlidertById = (id: any) =>
  createAsyncAction(
    GET_SLIDER_BY_ID,
    `/slideshow/get_slideshow_by_id/${id}`,
    "get",
    undefined
  );

export const editSlider = (id: any, data: any) =>
  createAsyncAction(
    EDIT_SLIDER,
    `/slideshow/edit_slideshow_by_id/${id}`,
    "put",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const removeSlider = (id: any) =>
  createAsyncAction(
    REMOVE_SLIDER,
    `/slideshow/remove_slideshow_by_id/${id}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
